import React from 'react'

const PlusIcon = ({ color, width, height, className, strokeWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth || '1.5'}
      stroke={color || 'currentColor'}
      className={className}
      width={width || '24'}
      height={height || '24'}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  )
}

export default PlusIcon
